const showOriginals = () => {
  document.getElementById('features-original').style.display = 'flex';
  document.getElementById('features-classics').style.display = 'none';
  document.getElementById('features-thermal').style.display = 'none';
  document.getElementById('features-originals-vegan').style.display = 'none';
  document.getElementById('features-lowcut').style.display = 'none';
  const textMessage = document.getElementById('features-breadcrumbs');
  const textMessageMobile = document.getElementById(
    'features-breadcrumbs-mobile',
  );
  textMessage.textContent = 'ORIGINALS';
  textMessageMobile.textContent = 'ORIGINALS';
};

const showClassics = () => {
  document.getElementById('features-classics').style.display = 'flex';
  document.getElementById('features-original').style.display = 'none';
  document.getElementById('features-thermal').style.display = 'none';
  document.getElementById('features-originals-vegan').style.display = 'none';
  document.getElementById('features-lowcut').style.display = 'none';
  const textMessage = document.getElementById('features-breadcrumbs');
  const textMessageMobile = document.getElementById(
    'features-breadcrumbs-mobile',
  );
  textMessage.textContent = 'CLASSICS';
  textMessageMobile.textContent = 'CLASSICS';
};

const showThermal = () => {
  document.getElementById('features-thermal').style.display = 'flex';
  document.getElementById('features-original').style.display = 'none';
  document.getElementById('features-classics').style.display = 'none';
  document.getElementById('features-originals-vegan').style.display = 'none';
  document.getElementById('features-lowcut').style.display = 'none';
  const textMessage = document.getElementById('features-breadcrumbs');
  const textMessageMobile = document.getElementById(
    'features-breadcrumbs-mobile',
  );
  textMessage.textContent = 'THERMAL';
  textMessageMobile.textContent = 'THERMAL';
};

const showOriginalsVegan = () => {
  document.getElementById('features-originals-vegan').style.display = 'flex';
  document.getElementById('features-thermal').style.display = 'none';
  document.getElementById('features-original').style.display = 'none';
  document.getElementById('features-classics').style.display = 'none';
  document.getElementById('features-lowcut').style.display = 'none';
  const textMessage = document.getElementById('features-breadcrumbs');
  const textMessageMobile = document.getElementById(
    'features-breadcrumbs-mobile',
  );
  textMessage.textContent = 'ORIGINALS VEGAN';
  textMessageMobile.textContent = 'ORIGINALS VEGAN';
};

const showLowcut = () => {
  document.getElementById('features-lowcut').style.display = 'flex';
  document.getElementById('features-originals-vegan').style.display = 'none';
  document.getElementById('features-thermal').style.display = 'none';
  document.getElementById('features-original').style.display = 'none';
  document.getElementById('features-classics').style.display = 'none';
  const textMessage = document.getElementById('features-breadcrumbs');
  const textMessageMobile = document.getElementById(
    'features-breadcrumbs-mobile',
  );
  textMessage.textContent = 'LOWCUT';
  textMessageMobile.textContent = 'LOWCUT';
};

const swiper = new Swiper('.swiper', {
  slidesPerView: 2,
  breakpoints: {
    768: {
      slidesPerView: 3,
    },
    1024: {
      slidesPerView: 5,
      spaceBetween: 20,
    },
  },
  direction: 'horizontal',

  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});

$(document).ready(function(){
  $(".collection_fv-img").slick({
    autoplay: true,
    autoplaySpeed: 2000,
    speed: 1500,
    dots: true,
    arrows: true,
    infinite: true,
    pauseOnHover: false,
    prevArrow: '<button class="slide-arrow prev-arrow"></button>',
    nextArrow: '<button class="slide-arrow next-arrow"></button>',
  });
});
